import { render } from "./EmployeeReturns.vue?vue&type=template&id=9dbf1c2c&scoped=true"
import script from "./EmployeeReturns.vue?vue&type=script&lang=js"
export * from "./EmployeeReturns.vue?vue&type=script&lang=js"

import "./EmployeeReturns.vue?vue&type=style&index=0&id=9dbf1c2c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dbf1c2c"]])

export default __exports__